var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnapchat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_101_4",
    transform: "scale(0.0588235 0.0625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_101_4",
    width: 17,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAMAAADH72RtAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABAlBMVEUAAAAjHyA2MjN+e3ydm5uHhYU9OTojHyAjHyB2c3T9/f3+/v6OjIwjHyBMSUr///9oZWYjHyAjHyC2tLXKycojHyDR0NHf3t8jHyAjHyDKycnZ2NkjHyAvKywjHyDDwsPY19gjHyA6NzgjHyB4dnff3t/////p6OiAfn4jHyAjHyAnIyTv7u709PQoJCUpJSb4+Pj8/PwwLC0jHyCsq6u0s7MjHyAlISKfnZ6hn6AnIyQjHyA0MTHa2dne3t43MzQjHyAjHyBiX2B6eHgjHyAjHyAjHyBJRkY4NDVsamr4+Ph4dnc2MjNCPz8pJSYjHyAsKSp7eXl7eXkvKyz///8AAAAMMFBZAAAAVHRSTlMAG6DHysWhIjDN8vXJNcH5uwEVycouys5AK8nMGJeNyc2XnxzQ2P3bzjITl9jfn5zm7JlNzctEgM3LcRDr19fnJHjSz4gtYq+qzeTOsLdvDJDKw5FlyLZKAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAAN0QAADdEBwivf4wAAAKBJREFUGNNNz9USwkAMBdAFintxl6KF4u7uTv7/W2i72dL7lJzZm5klRInBaOLMFivRYrM7AMDpcmvi8YIanx+BD1CAYIiVwiiRKEosjpKgkkylMyjZXF5QOoViCQXKlarySKzVEaQGT+80WyjtDoVuj5WgP5B3YTiCf8aTKZnNQZ/FkqzWGx1sd3u5dziezpK8Xa63+4N99fl6c5+vqM4/57wxH4KjeJQAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapchat);
export default __webpack_public_path__ + "static/media/snapchat.a0d6a0560b39cef1e9fe587a0ef94902.svg";
export { ForwardRef as ReactComponent };